// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.payment-container {
    background: white;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 600px;
    width: 100%;
    overflow: hidden;
    animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.payment-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 3rem 2rem;
    text-align: center;
}

.payment-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
    animation: bounce 2s infinite;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

.payment-header h1 {
    margin: 0;
    font-size: 2rem;
    font-weight: 700;
}

.payment-header p {
    margin: 0.5rem 0 0;
    opacity: 0.9;
    font-size: 1rem;
}

.payment-form {
    padding: 2rem;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: #374151;
    font-weight: 600;
    font-size: 0.95rem;
}

.form-control {
    width: 100%;
    padding: 0.875rem 1rem;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.3s ease;
    box-sizing: border-box;
    font-family: inherit;
}

.form-control:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.user-details {
    background: #f9fafb;
    padding: 1.5rem;
    border-radius: 12px;
    margin-bottom: 1.5rem;
}

.user-details h3 {
    margin: 0 0 1rem;
    color: #1f2937;
    font-size: 1.1rem;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e5e7eb;
}

.detail-row:last-child {
    border-bottom: none;
}

.detail-row .label {
    color: #6b7280;
    font-weight: 500;
}

.detail-row .value {
    color: #1f2937;
    font-weight: 600;
}

.pay-button {
    width: 100%;
    padding: 1.125rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1.125rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.pay-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
}

.pay-button:active:not(:disabled) {
    transform: translateY(0);
}

.pay-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spinner {
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.security-note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 1.5rem;
    padding: 1rem;
    background: #ecfdf5;
    border-radius: 8px;
}

.lock-icon {
    font-size: 1.25rem;
}

.security-note p {
    margin: 0;
    color: #059669;
    font-size: 0.875rem;
    font-weight: 500;
}

.payment-methods {
    padding: 2rem;
    background: #f9fafb;
    border-top: 1px solid #e5e7eb;
}

.payment-methods>p {
    margin: 0 0 1rem;
    color: #6b7280;
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.methods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 0.75rem;
    gap: 0.75rem;
}

.method {
    background: white;
    padding: 0.75rem;
    border-radius: 8px;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    border: 2px solid #e5e7eb;
    transition: all 0.3s ease;
}

.method:hover {
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    font-size: 1.5rem;
    color: white;
}

/* Error Box */
.error-box {
    background: #fee2e2;
    border: 2px solid #ef4444;
    border-radius: 12px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    animation: shake 0.5s ease-in-out;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.error-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
}

.error-box strong {
    display: block;
    color: #991b1b;
    margin-bottom: 0.25rem;
    font-size: 1rem;
}

.error-box p {
    margin: 0;
    color: #7f1d1d;
    font-size: 0.875rem;
    line-height: 1.5;
}

/* Loan EMI Details */
.loan-emi-details {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 2px solid #0ea5e9;
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.loan-emi-details h3 {
    margin: 0 0 1rem;
    color: #0c4a6e;
    font-size: 1.1rem;
    font-weight: 700;
}

.emi-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.75rem;
    gap: 0.75rem;
    margin-bottom: 1rem;
}

.emi-item {
    background: white;
    padding: 0.75rem;
    border-radius: 8px;
    border: 1px solid #bae6fd;
    transition: all 0.3s ease;
}

.emi-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.2);
}

.emi-item.highlight {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-color: #667eea;
}

.emi-item.highlight .emi-label,
.emi-item.highlight .emi-value {
    color: white;
}

.emi-label {
    display: block;
    font-size: 0.75rem;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
}

.emi-value {
    display: block;
    font-size: 1rem;
    color: #0c4a6e;
    font-weight: 700;
}

.late-fee-note {
    background: rgba(14, 165, 233, 0.12);
    border: 1px solid rgba(14, 165, 233, 0.3);
    color: #0c4a6e;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    margin-bottom: 1rem;
}

.late-fee-note.late {
    background: rgba(239, 68, 68, 0.12);
    border-color: rgba(239, 68, 68, 0.35);
    color: #991b1b;
    font-weight: 600;
}

.status-badges {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 1rem;
}

.badge {
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-success {
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #10b981;
}

.badge-info {
    background: #dbeafe;
    color: #1e40af;
    border: 1px solid #3b82f6;
}

.form-control:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
    opacity: 0.7;
}

/* Responsive Design */
@media (max-width: 768px) {
    .payment-page {
        padding: 1rem;
    }

    .payment-header {
        padding: 2rem 1.5rem;
    }

    .payment-header h1 {
        font-size: 1.5rem;
    }

    .payment-form {
        padding: 1.5rem;
    }

    .methods-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .payment-icon {
        font-size: 3rem;
    }

    .payment-header h1 {
        font-size: 1.25rem;
    }

    .form-control {
        padding: 0.75rem;
    }

    .pay-button {
        padding: 1rem;
        font-size: 1rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PaymentPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,+EAA+E;AACnF;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,iBAAY;IAAZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,cAAc;AACd;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAY;IAAZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;AACJ","sourcesContent":[".payment-page {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.payment-container {\n    background: white;\n    border-radius: 24px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    max-width: 600px;\n    width: 100%;\n    overflow: hidden;\n    animation: slideUp 0.5s ease-out;\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.payment-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 3rem 2rem;\n    text-align: center;\n}\n\n.payment-icon {\n    font-size: 4rem;\n    margin-bottom: 1rem;\n    animation: bounce 2s infinite;\n}\n\n@keyframes bounce {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n.payment-header h1 {\n    margin: 0;\n    font-size: 2rem;\n    font-weight: 700;\n}\n\n.payment-header p {\n    margin: 0.5rem 0 0;\n    opacity: 0.9;\n    font-size: 1rem;\n}\n\n.payment-form {\n    padding: 2rem;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #374151;\n    font-weight: 600;\n    font-size: 0.95rem;\n}\n\n.form-control {\n    width: 100%;\n    padding: 0.875rem 1rem;\n    border: 2px solid #e5e7eb;\n    border-radius: 12px;\n    font-size: 1rem;\n    transition: all 0.3s ease;\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n.form-control:focus {\n    outline: none;\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.user-details {\n    background: #f9fafb;\n    padding: 1.5rem;\n    border-radius: 12px;\n    margin-bottom: 1.5rem;\n}\n\n.user-details h3 {\n    margin: 0 0 1rem;\n    color: #1f2937;\n    font-size: 1.1rem;\n}\n\n.detail-row {\n    display: flex;\n    justify-content: space-between;\n    padding: 0.5rem 0;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.detail-row:last-child {\n    border-bottom: none;\n}\n\n.detail-row .label {\n    color: #6b7280;\n    font-weight: 500;\n}\n\n.detail-row .value {\n    color: #1f2937;\n    font-weight: 600;\n}\n\n.pay-button {\n    width: 100%;\n    padding: 1.125rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 12px;\n    font-size: 1.125rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n}\n\n.pay-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);\n}\n\n.pay-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.pay-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.spinner {\n    width: 20px;\n    height: 20px;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.security-note {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    margin-top: 1.5rem;\n    padding: 1rem;\n    background: #ecfdf5;\n    border-radius: 8px;\n}\n\n.lock-icon {\n    font-size: 1.25rem;\n}\n\n.security-note p {\n    margin: 0;\n    color: #059669;\n    font-size: 0.875rem;\n    font-weight: 500;\n}\n\n.payment-methods {\n    padding: 2rem;\n    background: #f9fafb;\n    border-top: 1px solid #e5e7eb;\n}\n\n.payment-methods>p {\n    margin: 0 0 1rem;\n    color: #6b7280;\n    font-size: 0.875rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.methods-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 0.75rem;\n}\n\n.method {\n    background: white;\n    padding: 0.75rem;\n    border-radius: 8px;\n    text-align: center;\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #374151;\n    border: 2px solid #e5e7eb;\n    transition: all 0.3s ease;\n}\n\n.method:hover {\n    border-color: #667eea;\n    color: #667eea;\n    transform: translateY(-2px);\n}\n\n.loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    font-size: 1.5rem;\n    color: white;\n}\n\n/* Error Box */\n.error-box {\n    background: #fee2e2;\n    border: 2px solid #ef4444;\n    border-radius: 12px;\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    animation: shake 0.5s ease-in-out;\n}\n\n@keyframes shake {\n\n    0%,\n    100% {\n        transform: translateX(0);\n    }\n\n    25% {\n        transform: translateX(-5px);\n    }\n\n    75% {\n        transform: translateX(5px);\n    }\n}\n\n.error-icon {\n    font-size: 1.5rem;\n    flex-shrink: 0;\n}\n\n.error-box strong {\n    display: block;\n    color: #991b1b;\n    margin-bottom: 0.25rem;\n    font-size: 1rem;\n}\n\n.error-box p {\n    margin: 0;\n    color: #7f1d1d;\n    font-size: 0.875rem;\n    line-height: 1.5;\n}\n\n/* Loan EMI Details */\n.loan-emi-details {\n    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n    border: 2px solid #0ea5e9;\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    animation: slideIn 0.5s ease-out;\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.loan-emi-details h3 {\n    margin: 0 0 1rem;\n    color: #0c4a6e;\n    font-size: 1.1rem;\n    font-weight: 700;\n}\n\n.emi-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n}\n\n.emi-item {\n    background: white;\n    padding: 0.75rem;\n    border-radius: 8px;\n    border: 1px solid #bae6fd;\n    transition: all 0.3s ease;\n}\n\n.emi-item:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(14, 165, 233, 0.2);\n}\n\n.emi-item.highlight {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border-color: #667eea;\n}\n\n.emi-item.highlight .emi-label,\n.emi-item.highlight .emi-value {\n    color: white;\n}\n\n.emi-label {\n    display: block;\n    font-size: 0.75rem;\n    color: #64748b;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n}\n\n.emi-value {\n    display: block;\n    font-size: 1rem;\n    color: #0c4a6e;\n    font-weight: 700;\n}\n\n.late-fee-note {\n    background: rgba(14, 165, 233, 0.12);\n    border: 1px solid rgba(14, 165, 233, 0.3);\n    color: #0c4a6e;\n    border-radius: 10px;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    margin-bottom: 1rem;\n}\n\n.late-fee-note.late {\n    background: rgba(239, 68, 68, 0.12);\n    border-color: rgba(239, 68, 68, 0.35);\n    color: #991b1b;\n    font-weight: 600;\n}\n\n.status-badges {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-top: 1rem;\n}\n\n.badge {\n    padding: 0.5rem 1rem;\n    border-radius: 20px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-success {\n    background: #d1fae5;\n    color: #065f46;\n    border: 1px solid #10b981;\n}\n\n.badge-info {\n    background: #dbeafe;\n    color: #1e40af;\n    border: 1px solid #3b82f6;\n}\n\n.form-control:disabled {\n    background-color: #f3f4f6;\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .payment-page {\n        padding: 1rem;\n    }\n\n    .payment-header {\n        padding: 2rem 1.5rem;\n    }\n\n    .payment-header h1 {\n        font-size: 1.5rem;\n    }\n\n    .payment-form {\n        padding: 1.5rem;\n    }\n\n    .methods-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 480px) {\n    .payment-icon {\n        font-size: 3rem;\n    }\n\n    .payment-header h1 {\n        font-size: 1.25rem;\n    }\n\n    .form-control {\n        padding: 0.75rem;\n    }\n\n    .pay-button {\n        padding: 1rem;\n        font-size: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
